import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from './jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import { Box, Typography, TextField } from '@mui/material';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useSelector } from 'react-redux';
import { getJsonEditor, getSessionId } from '../../store';
import jsonConstants from '../../constants/jsonConstants';

interface userFeedbackUIProps {
  closeComponent: any;
}

const sendFeedback = (
  feedback: string,
  emailAddress: string,
  sessionId: string,
  editorState: any,
  setShowThankYou: any,
  setShowError: any,
) => {
  let feedbackJson = JSON.stringify({ userFeedback: feedback, userEmail: emailAddress, policyJson: editorState });
  fetch(`${jsonConstants.feedbackSubmitUrl}${sessionId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain',
    },
    body: `${btoa(feedbackJson)}`,
  }).then((r) => {
    if (r.ok) {
      setShowThankYou(true);
    } else {
      setShowError(true);
    }
  });
};

const UserFeedbackUIComponent = ({ closeComponent }: userFeedbackUIProps) => {
  const editorState = useSelector(getJsonEditor);
  const sessionId = useSelector(getSessionId);
  const classes: any = jsonEditorStyles();
  const [feedback, setFeedback] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [showThankYou, setShowThankYou] = useState(false);
  const [showError, setShowError] = useState(false);

  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          setShowThankYou(false);
          setShowError(false);
          closeComponent();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.modalStyle}
    >
      <div className={classes.popup}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>Feedback</div>
          <div>
            <ClearOutlinedIcon
              onClick={() => {
                setShowThankYou(false);
                setShowError(false);
                closeComponent();
              }}
              className={classes.delete}
            />
          </div>
        </div>
        {!showThankYou && !showError && (
          <>
            <div className={cn(classes.flexCol)}>
              <Typography variant="h5" sx={{ my: 2, mx: 8 }}>
                Please give us any feedback you have on the IEF Editor below.
              </Typography>
              <TextField
                label="Email"
                sx={{ my: 2, mx: 8, width: '80%' }}
                value={emailAddress}
                onChange={(e) => {
                  setEmailAddress(e.target.value);
                }}
              />
              <TextField
                label="Feedback"
                sx={{ mx: 8, my: 1, width: '80%' }}
                multiline
                fullWidth
                minRows="6"
                maxRows="9"
                value={feedback}
                onChange={(e) => {
                  setFeedback(e.target.value);
                }}
              />
            </div>
            <Box sx={{ py: 2 }} className={cn(classes.flexSpacedRow)}>
              <div style={{ flex: '2' }} />
              <Button
                sx={{ flexBasis: '0', flex: '1' }}
                variant="contained"
                disabled={feedback.length == 0}
                onClick={() => {
                  sendFeedback(feedback, emailAddress, sessionId, editorState, setShowThankYou, setShowError);
                  setShowThankYou(true);
                }}
              >
                Send Feedback
              </Button>
              <div style={{ flex: '2' }} />
              <Button
                sx={{ flexBasis: '0', flex: '1' }}
                variant="contained"
                onClick={() => {
                  setShowThankYou(false);
                  setShowError(false);
                  closeComponent();
                }}
              >
                Cancel
              </Button>
              <div style={{ flex: '2' }} />
            </Box>
          </>
        )}
        {showThankYou && !showError && (
          <>
            <div className={cn(classes.flexSpacedRow)}>
              <Typography variant="h5" sx={{ py: 8 }}>
                Thank you for sending your feedback!
              </Typography>
            </div>
            <Box sx={{ py: 2 }} className={cn(classes.flexSpacedRow)}>
              <div style={{ flex: '2' }} />
              <Button
                sx={{ flexBasis: '0', flex: '1' }}
                variant="contained"
                onClick={() => {
                  setShowThankYou(false);
                  setShowError(false);
                  closeComponent();
                }}
              >
                Close
              </Button>
              <div style={{ flex: '2' }} />
            </Box>
          </>
        )}
        {!showThankYou && showError && (
          <>
            <div className={cn(classes.flexSpacedRow)}>
              <Typography variant="h5" sx={{ py: 8 }}>
                An error occurred sending feedback.
              </Typography>
            </div>
            <Box sx={{ py: 2 }} className={cn(classes.flexSpacedRow)}>
              <div style={{ flex: '2' }} />
              <Button
                sx={{ flexBasis: '0', flex: '1' }}
                variant="contained"
                onClick={() => {
                  setShowThankYou(false);
                  setShowError(false);
                  closeComponent();
                }}
              >
                Close
              </Button>
              <div style={{ flex: '2' }} />
            </Box>
          </>
        )}
      </div>
    </Modal>
  );
};

// export default withAITracking(reactPlugin, UserFeedbackUIComponent);
export default UserFeedbackUIComponent;
